import { useState, useRef } from 'react';
import { observeClickOutside } from 'react-ref-observe';
import { Icon } from '@eti/components';
import { etiColors } from '@eti/styles';
import { LegendBar, LegendWrapper, ChildWrapper, ToggleWrapper, iconClassName } from './StyledComponents';
import SeatCharacteristic from './SeatCharacteristic';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SeatMapLegend = _ref => {
  let {
    bestPriceCharacteristics,
    handleBackDrop,
    legendRef
  } = _ref;
  const ref = useRef();
  const [isOpen, setIsOpen] = useState(false);
  observeClickOutside([ref], () => {
    setIsOpen(false);
    handleBackDrop(false);
  });
  const handleToggle = () => {
    setIsOpen(prev => !prev);
    handleBackDrop(!isOpen);
  };
  return /*#__PURE__*/_jsx(LegendBar, {
    innerRef: legendRef,
    isOpen: isOpen,
    children: /*#__PURE__*/_jsxs(LegendWrapper, {
      innerRef: ref,
      children: [/*#__PURE__*/_jsxs(ChildWrapper, {
        isOpen: isOpen,
        children: [bestPriceCharacteristics.map(item => /*#__PURE__*/_jsx(SeatCharacteristic, {
          characteristic: item.characteristic,
          isOpen: isOpen,
          priceFrom: item.price
        }, item.characteristic)), /*#__PURE__*/_jsx(SeatCharacteristic, {
          isOpen: isOpen,
          isUnavailable: true
        })]
      }), /*#__PURE__*/_jsx(ToggleWrapper, {
        "data-testid": "seatMap-expandLegendButton",
        onClick: handleToggle,
        children: /*#__PURE__*/_jsx(Icon, {
          className: iconClassName(!isOpen),
          color: etiColors.grayScale[10],
          id: "chevron-down",
          size: "1rem"
        })
      })]
    })
  });
};
export default SeatMapLegend;
//# sourceMappingURL=SeatMapLegend.js.map